import createHistory from 'history/createBrowserHistory';
export default createHistory();


// WEBPACK FOOTER //
// ./node_modules/linksoft/src/history.js